import styled, { css } from "styled-components";
import { getToggleStyles, TToggleSize } from "./helpers";

export const Wrapper = styled.label<{
    $disabled: boolean;
    $checked: boolean;
    $size: TToggleSize;
}>`
    ${({ theme, $size, $checked, $disabled }) => {
        const styles = getToggleStyles(theme, $size, $checked);

        return css`
            --toggle-width: ${styles.width};
            --toggle-height: ${styles.height};
            --toggle-border-radius: ${styles.borderRadius};
            --toggle-slider-size: ${styles.sliderSize};
            --toggle-label-gap: ${styles.labelGap};

            ${$disabled
                ? css`
                      --toggle-border-color: ${styles.disabled.borderColor};
                      --toggle-background-color: ${styles.disabled.backgroundColor};
                      --toggle-slider-background-color: ${styles.disabled.sliderBackgroundColor};
                  `
                : css`
                      --toggle-border-color: ${styles.borderColor};
                      --toggle-background-color: ${styles.backgroundColor};
                      --toggle-slider-background-color: ${styles.sliderBackgroundColor};

                      ${Slider}:hover {
                          --toggle-border-color: ${styles.hover.borderColor};
                          --toggle-background-color: ${styles.hover.backgroundColor};
                          --toggle-slider-background-color: ${styles.hover.sliderBackgroundColor};
                      }

                      :focus,
                      :focus-within {
                          --toggle-border-color: ${styles.focus.borderColor};
                          --toggle-background-color: ${styles.focus.backgroundColor};
                          --toggle-slider-background-color: ${styles.focus.sliderBackgroundColor};
                          --toggle-ring-color: ${styles.focus.ringColor};
                      }
                  `}
        `;
    }}

    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
    position: relative;

    display: inline-flex;
    gap: var(--toggle-label-gap);
`;

export const HiddenInput = styled.input`
    -webkit-appearance: none;
    appearance: none;
    position: absolute;

    opacity: 0;
    width: 0;
    height: 0;
`;

export const Slider = styled.span<{ $checked: boolean }>`
    width: var(--toggle-width);
    height: var(--toggle-height);

    border: 1px solid var(--toggle-border-color);
    background-color: var(--toggle-background-color);
    border-radius: var(--toggle-border-radius);

    transition: 0.3s;

    position: relative;

    ::before {
        content: "";
        position: absolute;
        left: 1px;
        right: auto;
        top: 1px;

        width: var(--toggle-slider-size);
        height: var(--toggle-slider-size);

        background-color: var(--toggle-slider-background-color);
        border-radius: 50%;

        transition: 0.3s;

        ${({ $checked }) =>
            $checked &&
            css`
                transform: translateX(var(--toggle-slider-size));
            `}
    }

    ${HiddenInput}:focus ~ & {
        box-shadow: 0px 0px 0px 4px var(--toggle-ring-color);
    }
`;
